import Form from "react-bootstrap/Form";

import { createUUID } from "../../../shared/utils/utils";
import { ITableRowData } from "../normal-table/normal-table";

export interface IProps {
  onChange(): void;
  checked?: boolean;
  id?: string;
  readOnlyState?:boolean;
  rowData?: ITableRowData;
  label?: string;
}

function CheckboxInput({ onChange, readOnlyState, label, rowData, checked }: IProps) {
  const name = rowData && (rowData.name || rowData.input_field_name || rowData.dataset_name || rowData.modelversion_name || rowData.display_name);
  return (
    <Form.Check label={label} name={name || "selectAll"} disabled={readOnlyState} checked={!!checked} onChange={() => onChange()} type={"checkbox"} id={createUUID()} />
  );
}
export default CheckboxInput;
